import { pulseAxiosInstance } from "@pulse/api/axiosInstance";

export const getPulseInstanceById = async ({
    pulseInstanceId,
}: {
    pulseInstanceId: number;
}): Promise<PulseInstance> =>
    (await pulseAxiosInstance.get(`pulse-instances/${pulseInstanceId}`)).data;

export type PulseInstance = {
    id: number;
    productInstanceId: number;
};
